import { useState } from 'react';

const initialState = {
  filters: {},
  isOpen: false,
  selections: ['creator', 'division', 'live', 'project'],
  subtitle: '',
  title: '',
};

export default function useProjectsModal({
  domainDashboardConfigurableFields,
  isApprovalsEnabled,
  isFoldersEnabled,
  isProjectReviewDatesEnabled,
  isRiskRegisterEnabled,
}) {
  const additionalSelections = [
    isApprovalsEnabled && 'approval_status',
    isFoldersEnabled && 'folder',
    isProjectReviewDatesEnabled && 'review_date',
    isRiskRegisterEnabled && 'risk_assessments',
  ]
    .concat(
      domainDashboardConfigurableFields.data.map(
        (field) => `dashboard_configurable_field_${field.id}`,
      ),
    )
    .filter(Boolean);

  const selections = [...initialState.selections, ...additionalSelections];

  const [projectsModal, setProjectsModal] = useState({
    ...initialState,
    selections,
  });

  const openProjectsModal = ({ filters, subtitle, title }) => {
    setProjectsModal({
      filters,
      isOpen: true,
      selections,
      subtitle,
      title,
    });
  };

  const closeProjectsModal = () => {
    setProjectsModal({ ...initialState, selections });
  };

  return {
    closeProjectsModal,
    openProjectsModal,
    projectsModal,
  };
}
